import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import { ITransactionsDataDetail, ITransactionsData } from '@interfaces/transactions';
import Text from 'src/components/Text';
import Spinner from 'src/components/Spinner';
import { STATUS_LABEL_ARCHIVED } from 'src/global/theme/colors';
import { useGetTransactionDetail } from 'src/hooks/transactions';
import { Permissions } from 'src/auth/permissions/constants';
import { checkForPermission } from 'src/auth/permissions/utils';
import { useSelector } from 'react-redux';
import { getUserPermissions } from 'src/redux/reducers/user';

import { styles } from './styles';
import { makeArrayTransactionData } from './components';

interface Props {
  showDrawer: boolean;
  setShowDrawer: (isOpen: boolean) => void;
  transaction: ITransactionsData;
}

export default function DrawerInfoTransaction({ showDrawer, setShowDrawer, transaction }: Readonly<Props>) {
  const {
    data: transactionDetailResult,
    isFetching: isFetchingTransactionDetail,
    error: errorTransactions
  } = useGetTransactionDetail(transaction.id);
  const transactionDetail: ITransactionsDataDetail = transactionDetailResult?.data;
  const { classes } = styles();
  const permissions = useSelector(getUserPermissions);
  const hasP2mInfoPermission = checkForPermission(permissions, Permissions.PermissionsList.ReadP2mInfo);
  const dataList = makeArrayTransactionData(transaction, transactionDetail, hasP2mInfoPermission);
  const additionalInfoTransactionDetail = transactionDetailResult?.data.additional_info;
  const isLogDetailAvailable = hasP2mInfoPermission && additionalInfoTransactionDetail;
  const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }

    setShowDrawer(open);
  };

  const list = () => (
    <Box
      data-testid="box-list"
      sx={{ width: isLogDetailAvailable ? 900 : 384, height: '100%' }}
      role="presentation"
      onKeyDown={toggleDrawer(false)}>
      {isFetchingTransactionDetail ? (
        <Spinner />
      ) : (
        <>
          {errorTransactions ? (
            <Text variant="Caption-Regular" style={{ padding: '16px' }} textAlign="center">
              Ocurrió un error al buscar el detalle de la transacción
            </Text>
          ) : (
            <div className={classes.containerDrawer}>
              <div>
                <Text variant="H1-Bold">Detalle</Text>
              </div>

              {dataList.filter((obj) => obj.title || obj.component).map((obj) => (
                <div key={`drawer-info-${obj.title ?? 'untitled'}`} className={classes.divider}>
                  {!!obj.title && (
                    <div className={classes.divider}>
                      <Text variant="Caption-Regular" color={STATUS_LABEL_ARCHIVED}>
                        {obj.title}
                      </Text>
                    </div>
                  )}

                  <div>{obj.component}</div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </Box>
  );

  return (
    <div>
      <React.Fragment key={'right'}>
        <Drawer anchor={'right'} open={showDrawer} onClose={toggleDrawer(false)}>
          {list()}
        </Drawer>
      </React.Fragment>
    </div>
  );
}
